import React from 'react'
import BaseTooltip from '../../../../components/BaseTooltip'
import { IconButton } from '@mui/material'
import Swal from 'sweetalert2'
import { SyncAlt } from '@mui/icons-material'
import { func, number, object } from 'prop-types'

export default function DevolverEmprestimo({ row, execute }) {
  return (
    <BaseTooltip light title="Devolver exemplar">
      <IconButton
        onClick={() => {
          Swal.fire({
            title: 'Devolver Empréstimo',
            html: 'Deseja devolver o empréstimo do leitor <br/>' + row.leitor,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, devolver',
            cancelButtonText: 'Cancelar'
          }).then(result => {
            if (result.isConfirmed) {
              execute(row.id)
            }
          })
        }}
        color="primary"
      >
        <SyncAlt />
      </IconButton>
    </BaseTooltip>
  )
}
DevolverEmprestimo.propTypes = {
  row: {
    id: number,
    leitor: object
  },
  execute: func
}
